import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=eb79586e&scoped=true&"
import script from "./feature-card.vue?vue&type=script&lang=js&"
export * from "./feature-card.vue?vue&type=script&lang=js&"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=eb79586e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb79586e",
  null
  
)

export default component.exports